const WORDS = [
  { text: "CONFIANZA", top: "10%", left: "3%", size: "clamp(2.5rem, 6vw, 5rem)", dur: 26, delay: 0, silver: false },
  { text: "TRUST", top: "26%", left: "58%", size: "clamp(2rem, 5vw, 4rem)", dur: 32, delay: -6, silver: true },
  { text: "PODER", top: "44%", left: "8%", size: "clamp(2.5rem, 6vw, 5.5rem)", dur: 28, delay: -12, silver: false },
  { text: "ALLIANCE", top: "60%", left: "62%", size: "clamp(1.8rem, 4.5vw, 3.5rem)", dur: 36, delay: -18, silver: true },
  { text: "SEGURIDAD", top: "76%", left: "5%", size: "clamp(2rem, 5vw, 4rem)", dur: 30, delay: -9, silver: true },
  { text: "POWER", top: "18%", left: "72%", size: "clamp(2.2rem, 5.5vw, 4.5rem)", dur: 34, delay: -22, silver: false },
  { text: "ALIANZA", top: "52%", left: "34%", size: "clamp(2rem, 5vw, 4.2rem)", dur: 27, delay: -15, silver: false },
  { text: "DESEO", top: "84%", left: "52%", size: "clamp(2.4rem, 6vw, 5rem)", dur: 31, delay: -4, silver: false },
  { text: "SECURITY", top: "38%", left: "76%", size: "clamp(1.6rem, 4vw, 3rem)", dur: 38, delay: -26, silver: true },
  { text: "CONFIDENCE", top: "68%", left: "22%", size: "clamp(1.7rem, 4.2vw, 3.2rem)", dur: 35, delay: -20, silver: true },
];

export function Subliminal() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-[1] overflow-hidden select-none" data-testid="subliminal-layer">
      {WORDS.map((w) => (
        <span
          key={w.text + w.top}
          className="subliminal-word"
          style={{
            top: w.top,
            left: w.left,
            fontSize: w.size,
            color: w.silver ? "#B8BEC7" : "#C9A227",
            animationDuration: `${w.dur}s`,
            animationDelay: `${w.delay}s`,
          }}
        >
          {w.text}
        </span>
      ))}
    </div>
  );
}
